function load_google_places_autocomplete() {
    const autocompletes = document.querySelectorAll('.google-places-autocomplete');
    autocompletes.forEach((autocomplete)=>{
        new google.maps.places.Autocomplete(autocomplete);
    });
}
window.addEventListener('ready', load_google_places_autocomplete);
window.addEventListener('turbolinks:load', load_google_places_autocomplete);
